// extracted by mini-css-extract-plugin
module.exports = {"subtitleWrapper":"LocationAndTime--subtitle-wrapper--2cGLk","location":"LocationAndTime--location--22nOH"};